'use client';

import { type Control, type FieldValues, useFormState } from 'react-hook-form';

/**
 * Renders the form-level server error set by applyActionResult on
 * root.serverError. Mirrors the existing form-error paragraph styling.
 */
export function FormRootError<T extends FieldValues>({
  control,
}: {
  control: Control<T>;
}) {
  const { errors } = useFormState({ control });
  const message = errors.root?.serverError?.message;
  if (!message) return null;
  return <p className="text-ds-destructive text-2xs">{message}</p>;
}
